/* eslint-disable max-len */
// @flow
import moment from 'moment';
import { NOTIFICATION_TYPE_ENUM } from '../constants';
import * as AppState from '../../../state/reducer/app/appState';
import * as Authorization from '../../../lib/authorization';
import type { Notification } from '../constants';

export default class NotificationRouter {
    static route(type: number, notification: Notification) {
        if (!NotificationRouter[type]) {
            return;
        }

        return NotificationRouter[type](notification);
    }

    static [NOTIFICATION_TYPE_ENUM.FEED_COMMENT_TEAM] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_COMMENT_ONE_TO_ONE] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_REPLY_AUTHOR_TEAM] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_REPLY_DISCUSSION_TEAM] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_REPLY_ONE_TO_ONE] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_LIKE_TEAM] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.FEED_LIKE_ONE_TO_ONE] = navigateToFeedItem;
    static [NOTIFICATION_TYPE_ENUM.EXERCISE_COMMENT] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.CIRCUIT_COMMENT] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_REPLY] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_REPLY_AUTHOR] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_COMMENT] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_REPLY_LIKE] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_SUMMARY_COMMENT] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_SUMMARY_COMMENT_SHARE_WITH_TEAM] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_LIKE] = navigateToCalendarDrawer;
    static [NOTIFICATION_TYPE_ENUM.SESSION_COMPLETE_ONE_TO_ONE] = navigateToCalendarDrawer;
}

function navigateToFeedItem(notification: Notification) {
    const isAuthorized =
        Authorization.navigateToTeamFeed.isAllowed() ||
        Authorization.navigateToAthleteFeed.isAllowed();

    if (!isAuthorized) {
        return AppState.showUnauthorizedDialog();
    }

    const { athleteId, teamId, feedItemId } = notification.metadata;
    let url;
    if (athleteId) {
        url =
            Authorization.navigateToAthleteFeed.path +
            athleteId +
            `?feedItemId=${feedItemId}`;
    } else {
        url =
            Authorization.navigateToTeamFeed.path +
            teamId +
            `?feedItemId=${feedItemId}`;
    }

    window.location = url;
}

export function navigateToCalendarDrawer(notification: Notification) {
    const {
        athleteId,
        programId,
        workoutId,
        programWorkoutTimestamp,
        sessionDate
    } = notification.metadata;

    let date;
    if (programWorkoutTimestamp) {
        date = moment
            .unix(programWorkoutTimestamp)
            .utc()
            .format('YYYY-MM-DD');
    }

    if (sessionDate) {
        date = moment(sessionDate);
    }

    const year = moment(date).get('year');
    // moment returns 0 - 11 for month
    const month = moment(date).get('month') + 1;
    const workoutParam = `?workoutId=${workoutId}`;

    let url;
    if (athleteId) {
        url = `/athlete/${athleteId}/${year}/${month}` + workoutParam;
    } else {
        url = `/team/${programId}/${year}/${month}` + workoutParam;
    }

    AppState.navigate(url);
    return url;
}



// WEBPACK FOOTER //
// ./src/v5/notifications/utilities/notificationRouter.js